export interface OfficeResponse {
  id: string;
  name: string;
  status: OfficeStatus;
  address: string;
  officerCount: number;
  code: string;
  email: string;
  createdById: string;
  createdByName: string;
  dateAdded: string;
  officeType: OfficeType;
  officers: any;
  locationId: string;
  organizationId: string;
  managers: any;
  officeLevel: EOfficeLevel;
  jurisdiction: OfficeJurisdiction;
}

export enum OfficeStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum OfficeType {
  LOCATION = 'LOCATION',
  BRANCH = 'BRANCH',
  EMBASSY = 'EMBASSY',
  OTHER = 'OTHER',
}

export enum EOfficeLevel {
  LEVEL_1 = 'LEVEL_1',
  LEVEL_2 = 'LEVEL_2',
  LEVEL_3 = 'LEVEL_3',
  LEVEL_4 = 'LEVEL_4',
  LEVEL_5 = 'LEVEL_5',
  LEVEL_6 = 'LEVEL_6',
  LEVEL_7 = 'LEVEL_7',
  LEVEL_8 = 'LEVEL_8',
  LEVEL_9 = 'LEVEL_9',
  LEVEL_10 = 'LEVEL_10',
}

export enum OfficeJurisdiction {
  COUNTRY = 'COUNTRY',
  PROVINCE = 'PROVINCE',
  DISTRICT = 'DISTRICT',
  SECTOR = 'SECTOR',
  CELL = 'CELL',
  VILLAGE = 'VILLAGE',
}

export interface OfficeFilterParams {
  page?: number;
  size?: number;
  level?: EOfficeLevel;
  organisationId?: string;
}
